<div class="input-inline">
  <div *ngIf="!editing" class="text" [class.placeholder]="!value?.length" (appDblClick)="startEdit()">{{ value?.length ? value : placeholder }}</div>
  <input #input *ngIf="editing" class="input-inline-edit" [(ngModel)]="value" (blur)="endEdit()" (keydown.enter)="endEdit()" (keydown.escape)="endEdit()" autoSizeInput [includePlaceholder]="false" [minWidth]="1">
</div>
